import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { RootState } from '../redux/store';
import { setPrimetimeFilter } from '../redux/slices/appointmentSlice';
import { Button } from '../components/Button';
import Toggle from '../components/Toggle';
import PreferredTimeSlots from '../components/PreferredTimeSlots';
import { AvailableSlots } from '../components/AvailableSlots';

export const StepTimeSlot = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedSlot = useSelector((s: RootState) => s.appointment.selectedSlot);
  const primetimeFilter = useSelector((s: RootState) => s.appointment.primetimeFilter);
  const { practice } = useSelector((s: RootState) => s.auth);
  const [isFormValid, setIsFormValid] = useState(false);
  const isPracticeHasManualScheduler = practice?.scheduler_type === 'manual';
  
  const proceed = () => {
    navigate(`../step-4`);
  }; 

  return (
    <Layout>
      <div className="space-y-4">
        <div className='flex flex-col md:flex-row md:justify-between justify-center items-center'>
          <div className='flex flex-col items-center text-center md:items-start md:text-start'>
            <h1 className="text-2xl font-semibold text-black">When would you like to come?</h1>
            <p className="text-sm text-gray-500">Convenient evenings and weekends to fit your schedule</p>
          </div>
          {practice?.promote_primetime && (
            <div className='px-0 pt-5 md:pt-0 md:px-2'>
              <Toggle
                selected={primetimeFilter}
                onChange={(value) => dispatch(setPrimetimeFilter(value))}
              />
            </div>
          )}
        </div>
        {isPracticeHasManualScheduler ? (
          <PreferredTimeSlots onValidationChange={setIsFormValid} />
        ) : (
          <AvailableSlots />
        )}
        <div className="flex justify-between">
          <Button title='Back' variant='secondary' onClick={() => navigate('../step-2')} />
          <Button title='Continue' disabled={isPracticeHasManualScheduler ? !isFormValid : !selectedSlot} onClick={proceed} />                     
        </div>
      </div>
    </Layout>
  );
};
